import openSocket from "socket.io-client";
import { getBackendUrl } from "../config";

function connectToSocket() {
  let rawToken = localStorage.getItem("token");
  let token = null;

  if (rawToken && rawToken !== "undefined") {
    try {
      token = JSON.parse(rawToken);
    } catch (e) {
      console.error("Invalid token format in localStorage:", e);
    }
  }

  return openSocket(getBackendUrl(), {
    transports: ["websocket", "polling", "flashsocket"],
    query: {
      token,
    },
  });
}

export default connectToSocket;